import React from 'react';

function Tab({ servi, isActive, onClick }) {
    return (
        <button
            className={`tab-btn ${isActive ? 'active' : ''}`}
            onClick={onClick}
        >
            {servi?.name}
        </button>
    );
}

export default Tab;
